import { useTranslation } from 'react-i18next'

import { Link, Outlet, useLocation } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

const tabClassName =
  'rounded-2xl px-3 py-1.5 text-sm font-medium text-muted-foreground'

export function LogsLayout() {
  const { t } = useTranslation()
  const pathname = useLocation({ select: (location) => location.pathname })

  return (
    <div className="m-2 flex h-[calc(100%-1rem)] min-h-0 flex-col overflow-hidden rounded-2xl bg-white/38">
      <nav
        aria-label={t('executionLogs.navTitle')}
        className="mx-3 mt-3 flex w-fit rounded-2xl bg-zinc-100 p-[3px]"
      >
        <Link
          to="/logs/user"
          search={pathname === '/logs/user' ? true : {}}
          activeOptions={{ exact: true, includeSearch: false }}
          className={tabClassName}
          activeProps={{
            className: cn(
              tabClassName,
              'bg-background text-foreground shadow-sm',
            ),
          }}
        >
          {t('userLogs.title')}
        </Link>
        <Link
          to="/logs/execution"
          search={pathname === '/logs/execution' ? true : {}}
          activeOptions={{ exact: true, includeSearch: false }}
          className={tabClassName}
          activeProps={{
            className: cn(
              tabClassName,
              'bg-background text-foreground shadow-sm',
            ),
          }}
        >
          {t('executionLogs.title')}
        </Link>
      </nav>
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  )
}
